import axios from 'axios';

// --- CONFIGURATION ---
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const NODE_API = `${BACKEND_URL}/api`;

// --- HELPER: Get Auth Header ---
const getHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

// --- API FUNCTIONS ---

// 1. AUTH
export const authAPI = {
  register: async (data) => {
    const response = await axios.post(`${NODE_API}/auth/register`, data);
    return response.data;
  },
  login: async (data) => {
    const response = await axios.post(`${NODE_API}/auth/login`, data);
    return response.data;
  },
  getMe: async () => {
    const response = await axios.get(`${NODE_API}/auth/me`, getHeaders());
    return response.data;
  },
};

// 2. PRODUCTS (Securely via Node Backend)
export const productsAPI = {
  getAll: async (params = {}) => {
    // Pass filters like { trending: true, limit: 4 } to backend
    const response = await axios.get(`${NODE_API}/products`, { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`${NODE_API}/products/${id}`);
    return response.data;
  },
};

// 3. CART (Strict Login Required)
export const cartAPI = {
  get: async () => {
    const response = await axios.get(`${NODE_API}/cart`, getHeaders());
    return response.data;
  },
  add: async (data) => {
    const response = await axios.post(`${NODE_API}/cart/add`, data, getHeaders());
    return response.data;
  },
  update: async (data) => {
    const response = await axios.put(`${NODE_API}/cart/update`, data, getHeaders());
    return response.data;
  },
  remove: async (id) => {
    const response = await axios.delete(`${NODE_API}/cart/${id}`, getHeaders());
    return response.data;
  },
};

// 4. WISHLIST
export const wishlistAPI = {
  get: async () => {
    const response = await axios.get(`${NODE_API}/wishlist`, getHeaders());
    return response.data;
  },
  toggle: async (productId) => {
    // Pass minimal product data for the toggle
    const response = await axios.post(`${NODE_API}/wishlist/toggle`, { product_id: productId }, getHeaders());
    return response.data;
  }
};

// 5. ORDERS
export const ordersAPI = {
  create: async (data) => {
    const response = await axios.post(`${NODE_API}/orders/create`, data, getHeaders());
    return response.data;
  },
  getMyOrders: async () => {
    const response = await axios.get(`${NODE_API}/orders/my-orders`, getHeaders());
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`${NODE_API}/orders/${id}`, getHeaders());
    return response.data;
  },
};

// 6. ADMIN
export const adminAPI = {
  getAllOrders: async () => {
    const response = await axios.get(`${NODE_API}/admin/orders`, getHeaders());
    return response.data;
  },
  getAllUsers: async () => {
    const response = await axios.get(`${NODE_API}/admin/users`, getHeaders());
    return response.data;
  }
};

// 7. PAYMENT
export const paymentAPI = {
  createRazorpayOrder: async () => {
    const response = await axios.post(`${NODE_API}/payment/create-order`, {}, getHeaders());
    return response.data;
  },
  verifyPayment: async (data) => {
    const response = await axios.post(`${NODE_API}/payment/verify`, data, getHeaders());
    return response.data;
  }
};

// 8. CATEGORIES (Added this missing route to server if needed, or mock it)
export const categoriesAPI = {
  getAll: async () => {
    // If you haven't made a categories route in server.js yet, you might need to add it there
    // For now, this assumes it exists:
    try {
        const response = await axios.get(`${NODE_API}/products`); 
        // Extract unique categories from products as a quick hack if specific category API missing
        const products = response.data;
        const categories = [...new Set(products.map(p => p.category))];
        return categories.map((c, i) => ({ id: i, name: c, slug: c.toLowerCase() }));
    } catch (e) {
        return [];
    }
  },
};

// --- INTERCEPTOR (Auto Logout) ---
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);